<template>
    <a-modal :closable="false"
            :visible="isVisible"
    >
        <template #footer>
				<a-button @click="handleBtnCancel">
					Cancel
				</a-button>

				<a-button type="primary" @click="handleBtnCreate" :loading="loading">
					Create
				</a-button>
			</template>

            <div>
                <a-form-model ref="categoryForm"  
						  	:model="category"
						  	:rules="categoryRules"
                >
                    <a-card :bordered="false" 
                            class="header-solid h-full" 
                            :bodyStyle="{paddingTop: 0, paddingBottom: '20px' }"
                    >
                        <a-row :gutter="[24]">
                            <a-form-model-item class="mb-10" 
												label="Category Name" 
												:colon="false"
												ref="categoryName"
												prop="categoryName"	   
							>
								<a-input allow-clear placeholder="eg. Minimal Bar Stool" 
												 	v-model="category.categoryName"
												 	@blur="() => { $refs.categoryName.onFieldBlur() }"
								/>
							</a-form-model-item>
                        </a-row>
                        <a-row :gutter="[24]">
                            <a-form-model-item class="mb-10" label="Description" :colon="false">
								<a-textarea v-model="category.description" :rows="2">
								</a-textarea>
							</a-form-model-item>
                        </a-row>
                    </a-card>
                </a-form-model>
            </div>
    </a-modal>
</template>

<script>
export default {
    data () {
        return {
            isVisible : false,
            loading : false,
            category : {
                categoryName : '',
                description : ''
            },
            categoryRules : {
				categoryName : [
					{
						required : true,
						message : 'The field cannot be empty',
						trigger: 'blur'
					},
                    {
						min: 3,
						message : 'The field should have at least 3 characters',
						trigger: 'blur'
					}
                ]
            }
        }
    },
    methods : {

        handleBtnCreate() {

            this.$refs.categoryForm.validate(async valid => {
                if (valid) {
                    this.loading = true;
                    let payload = {
                        name : this.category.categoryName,
                        description : this.category.description
                    }
                    await this.$store.dispatch('categories/createCategoryAction', payload);
                    await this.sleep(1000);
                    this.loading = false;
                    this.isVisible = false;   
                    this.clear();
                    
                }
            });
            
        },

        handleBtnCancel() {
            this.clear();
            this.isVisible = false;
        },
        showModal() {
            this.isVisible = true;

        },
        clear() {
            this.category.categoryName = '';
            this.category.description = '';
        },

        async sleep(miliSeconds) {
            return new Promise(r => setTimeout(r, miliSeconds));
        },


    }
}
</script>

<style>

</style>